import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
// Компоненты пользовательского интерфейса
import CustomButtonEdit from '../CustomElements/CustomButtonEdit';
import { Tab, Tabs } from '../CustomElements/Tabs';
import RailChains from './RailChains';
import Adjacency from './Adjacency';
import { useInfocard } from './Common';
import Semaphores from './Semaphores';
import Modal from '../Modal/Modal';
import CustomButton from '../CustomElements/CustomButton';
import CustomContainer from '../CustomElements/CustomContainer';
import ConfirmationPage from '../CustomElements/ConfirmationPage';
// Кастомные хуки
import useUrlNavigate from '../../customHook/useUrlNavigate';
import { useRole } from '../../customHook/useRole';
// Действия Redux
import {
  clearAdjacencyState,
  clearRailChainsState,
  clearSemaphoresState,
  editModeFromServer,
} from '../../redux/actions/infocards.action';

// Компонент для отображения и управления инфокартой

export default function InfocardView({ t }) {
  // Получение функции dispatch для отправки действий в Redux store.
  const dispatch = useDispatch();

  const [isOpen, setIsOpen] = useState(false);

  // Закрыть модальное окно
  const closeModal = () => {
    setIsOpen(false);
  };

  // роли пользователя
  const isAdmin = useRole('admin');

  // хук для навигации
  const changeURL = useUrlNavigate();

  // получаем данные для отображения инфокарты
  const {
    stationName,
    roadName,
    departmentName,
    maxSpeed,
    minDist,
    alertDist,
    direction,
    stationId,
    isDisabled,
    isStation,
  } = useInfocard();

  // Подготавливаем отображаемые значения
  const noDataAlias = t?.noData || 'н/д';
  const displayRoadName = roadName || noDataAlias;
  const displayDepartmentName = departmentName || noDataAlias;
  const displayMaxSpeed = maxSpeed ? `${maxSpeed} ${t?.unitSpeed || 'км/ч'}` : noDataAlias;
  const displayMinDist = minDist ? `${minDist} ${t?.unitMeter || 'м'}` : noDataAlias;
  const displayAlertDist = alertDist ? `${alertDist} ${t?.unitMeter || 'м'}` : noDataAlias;

  const editMode = () => {
    dispatch(editModeFromServer(stationId, { isDisabled: !isDisabled }));
    // закрываем модалку
    closeModal();
  };
  // при закрытии инфокарты сбрасываем стейт со смежностями, рц и семафорами обновляем
  useEffect(() => {
    return () => {
      dispatch(clearAdjacencyState());
      dispatch(clearRailChainsState());
      dispatch(clearSemaphoresState());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  return (
    <>
      <div className="d-flex flex-column flex-nowrap w-100 overflow-hidden h-100">
        <div id="card" className="cards__header cards__header__rebuild">
          <div className="infocard-card-block">
            {/* <h4 className="infocard-card-title">{name}</h4> */}
            <h4 className={`infocard-card-title ${!isDisabled ? 'status-available' : 'status-unavailable'}`}>
              {stationName}
            </h4>
            <h4 className={`infocard-card-title-ison ${!isDisabled ? 'status-available' : 'status-unavailable'}`}>
              {!isDisabled
                ? t?.statusAvailable || 'Доступно для работы бригад'
                : t?.statusUnavailable || 'Недоступно для работы бригад'}
            </h4>
          </div>
          <div className="infocard-text text-left">
            <span>
              <b>{t?.road || 'Дорога'}: </b>
              {displayRoadName}
            </span>
            <span>
              <b>{t?.department || 'Подразделение'}: </b>
              {displayDepartmentName}
            </span>
            <span>
              <b>{t?.type || 'Тип'}: </b>
              {isStation ? t?.station || 'Станция' : t?.segment || 'Перегон'}
            </span>
            <span>
              <b>{t?.direction || 'Направление'}: </b>
              {direction}
            </span>
          </div>
          <div className="infocard-text text-left">
            <span>
              <b>{t?.maxSpeed || 'Разрешенная макс. скорость'}: </b>
              {displayMaxSpeed}
            </span>
            <span>
              <b>{t?.minWarningDistance || 'Минимальное расстояние оповещения'}: </b>
              {displayMinDist}
            </span>
            <span>
              <b>{t?.alertDistance || 'Расст. тревоги при приближ. ПС с исправным УИППС'}: </b>
              {displayAlertDist}
            </span>
          </div>
          <span />
          {isAdmin && (
            <CustomButtonEdit
              className="device-edit-btn ms-auto mb-auto w-auto"
              onClick={() =>
                changeURL((u) => {
                  u.pathname = u.pathname.replace('/view', '/edit');
                })
              }
            />
          )}
          {isAdmin && (
            <div className="btn-is-on">
              <CustomButton
                width="var(--sadr-font-size-135)"
                minHeight="var(--sadr-font-size-40)"
                height="var(--sadr-font-size-40)"
                color="var(--sadr-error)"
                text={!isDisabled ? t?.disable || 'Отключить' : t?.enable || 'Включить'}
                onClick={() => {
                  setIsOpen(true);
                }}
              />
            </div>
          )}
        </div>
        <Tabs>
          <Tab name={t?.tabRailChains || 'Рельсовые цепи'} path="/rail_chain">
            <RailChains t={t} />
          </Tab>
          <Tab name={t?.tabAdjacency || 'Смежность'} path="/adjacency">
            <Adjacency t={t} />
          </Tab>
          <Tab name={t?.tabSemaphores || 'Светофоры'} path="/semaphores">
            <Semaphores t={t} />
          </Tab>
        </Tabs>
      </div>
      {isOpen && (
        <Modal isOpen={isOpen} onClose={closeModal} width="700px" height="450px">
          <CustomContainer>
            <ConfirmationPage
              onConfirm={editMode}
              onCancel={closeModal}
              confirmButtonText={t?.confirm || 'Подтвердить'}
              cancelButtonText={t?.cancel || 'Отмена'}
              confirmText={
                !isDisabled
                  ? t?.confirmDisable || 'Вы уверены, что хотите запретить доступ ?'
                  : t?.confirmEnable || 'Вы уверены, что хотите разрешить доступ ?'
              }
              btnWidth="var(--sadr-font-size-280)"
            />
          </CustomContainer>
        </Modal>
      )}
    </>
  );
}
